// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__33XaL","info":"Note_info__1K9Hy","note":"Note_note__38KgM","actions":"Note_actions__UeinY"};